import { render, staticRenderFns } from "./CodigoFooter.vue?vue&type=template&id=1323807d&scoped=true&"
import script from "./CodigoFooter.vue?vue&type=script&lang=ts&"
export * from "./CodigoFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CodigoFooter.vue?vue&type=style&index=0&id=1323807d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323807d",
  null
  
)

export default component.exports